<template>
    <div class="border-t-4 px-4 py-3 my-4 mx-auto" :class="[alertClass, widthClass]">
        <div class="flex">
            <div class="py-1">
                <font-awesome-icon fixed-width size="lg" :icon="icon" class="fill-current h-6 w-6 mr-4" :class="iconClass"></font-awesome-icon>
            </div>
            <div>
                <p class="font-bold">{{alertTitle}}</p>
                <p class="text-sm">
                    <slot></slot>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faExclamation, faInfo } from '@fortawesome/free-solid-svg-icons';
    import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons'

    export default {
        props: ['type', 'align', 'title', 'width'],

        data() {
            return {
                alertClass: [],
                widthClass: [],
                iconClass: [],
                icon: [],
                alertTitle: this.title ? this.title : 'Heads Up!',
            }
        },

        created() {
            library.add(faExclamation, faInfo, faCircleCheck, faCircleXmark);
            this.setClasses();
        },

        methods: {
            setClasses() {
                switch (this.type) {
                    case 'danger':
                        this.alertClass.push('bg-red-100 border-red-500 text-red-900');
                        this.iconClass = ['text-red-500'];
                        this.icon = ['far', 'circle-xmark'];
                        break;

                    case 'warning':
                        this.alertClass.push('bg-yellow-100 border-yellow-300 text-yellow-700');
                        this.iconClass = ['text-yellow-300'];
                        this.icon = ['fas', 'exclamation'];
                        break;

                    case 'info':
                        this.alertClass.push('bg-blue-100 border-blue-500 text-blue-900');
                        this.iconClass = ['text-blue-500'];
                        this.icon = ['fas', 'info'];
                        break;

                    default:
                        this.alertClass.push('bg-green-100 border-green-500 text-green-900');
                        this.iconClass = ['text-green-500'];
                        this.icon = ['far', 'circle-check'];
                        break;
                }

                switch(this.width) {
                    case '25':
                        this.widthClass = "w-full lg:w-1/4";
                        break;

                    case '50':
                        this.widthClass = "w-full lg:w-1/2";
                        break;

                    case '75':
                        this.widthClass = "w-full lg:w-3/4";
                        break;

                    default:
                        this.widthClass = 'w-full';
                        break;
                }
            }
        }
    }
</script>
